import { Rule } from 'antd/lib/form';

export const getRequiredRule = (message: string): Rule => ({
  required: true,
  message: message,
});

export const passwordRules: Rule[] = [
  {
    min: 8,
    message: 'Minimum 8 characters',
  },
  {
    type: 'string',
    pattern: /(?=.*\d)/,
    message: 'At least 1 number (0-9)',
  },
];

export const retypePasswordRules: Rule[] = [
  ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue('newPassword') === value) {
        return Promise.resolve();
      }
      return Promise.reject(new Error('Passwords must match'));
    },
  }),
]; 